import { Component } from '@angular/core';

@Component({
  selector: 'app-reload-view',
  templateUrl: './app-reload-view.component.html',
  styleUrls: ['./app-reload-view.component.scss']
})
export class AppReloadViewComponent {
  constructor() {}

  onReload() {
    location.reload();
  }
}
